<template>
  <div>
    <list
      row-key="OrderId"
      ref="list"
      unit="订单"
      :page="page"
      :query-params="params"
      :show-query="showQuery"
      :get-data-func="api.sendOrderList"
      @reset-query="$emit('reset-select')"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="订单编号">
          <el-input
            size="mini"
            v-model="params.OrderNo"
            placeholder="请输入订单编号"
            clearable
          />
        </el-form-item>
        <el-form-item label="用户昵称">
          <el-input
            size="mini"
            v-model="params.NickName"
            placeholder="请输入用户名称"
            clearable
          />
        </el-form-item>
        <el-form-item label="订单时间">
          <el-date-picker
            size="mini"
            v-model.trim="params.StartTime"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
          <span style="margin: 0 10px">-</span>
          <el-date-picker
            size="mini"
            v-model.trim="params.EndTime"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="OrderNo" label="订单编号" width="160px" />
        <el-table-column prop="NickName" label="用户昵称" />
        <el-table-column prop="SubTotal" label="订单总额" />
        <el-table-column prop="OrderDate" label="订单时间" width="160px" />
        <!-- <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.AddTime)}}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="ReceivingPerson" label="联系人" />
        <el-table-column prop="ReceivingPhone" label="联系电话" />
        <el-table-column prop="ReceivingAddress" label="收货地址" />
        <el-table-column
          prop="OrderState"
          label="订单状态"
          align="center"
          width="110px"
        >
          <template slot-scope="{ row }">
            <state :state="row.OrderState" />
          </template>
        </el-table-column>        
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import state from "./state";
export default {
  mixins: [listMixin],
  components: { list, state },
  props: {
    showCheckbox: {
      type: Boolean,
      default: false,
    },
    isDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      api: require("@/api/sale/order/order").default,
      params: {
        OrderNo: "",
        Status: null, //订单状态
        SendStatus: null, //发货状态
        PayStatus: null, //付款状态
        RefundStatus: null, //退款状态
      },
    };
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        resolve({ Count: 0, Data: [{ RecordId: 1 }] });
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>